import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import Filter from '@intelligence/components/Filter';
import * as filterKeyMap from '@intelligence/components/Filter/FilterBase/_config';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';

import type { IGenreRes } from '@intelligence/types/common';

interface IMarketProfilePCConsoleGamesFilter extends IBaseProps {
  entityType?: IEntityType;
  genresOptionsDataLoading?: boolean;
  genresOptionsData?: IGenreRes | null;
  regionOptions?: IRegion[] | null;
  getRadioOptionsTips?: Function;
  defaultValue?: IRecord;
  value: IRecord;
  onChange?: (value: IRecord, apiValue: IRecord) => void;
  onReset?: (value: IRecord) => void;
}

const MarketProfilePCConsoleGamesFilter: React.FC<IMarketProfilePCConsoleGamesFilter> = (props) => {
  const {
    style,
    className,
    entityType = PC_CONSOLE_COMBINE_ENTITY_TYPE,
    genresOptionsDataLoading,
    genresOptionsData,
    regionOptions,
    getRadioOptionsTips,
    defaultValue,
    value,
    onChange,
    onReset,
  } = props;

  const defaultInputList = {
    GENRETOR: {
      type: filterKeyMap.GENRETOR,
      key: filterKeyMap.GENRETOR,
      entityType,
      default: {
        source: 'iegg',
        mainGenres: [],
        subGenres: [],
      },
      disableAnnie: true,
      disableIegg: false,
      genresOptionsDataLoading: true,
      genresOptionsData: [],
      genreData: {
        genreRef: {
          current: {},
        },
        genreSource: 'iegg',
        mainGenres: [],
        subGenres: [],
      },
    },
    RANGE_TIME: {
      type: filterKeyMap.RANGE_TIME,
      key: filterKeyMap.RANGE_TIME,
      extendFilterType: filterKeyMap.RANGE_TIME_EXTEND_TYPE.singleMonth,
      typeList: ['month'],
      calendarType: 'month',
      showSelectType: false,
      showShortcut: true,
      default: [undefined, undefined],
    },
    REGION: {
      type: filterKeyMap.REGION,
      key: filterKeyMap.REGION,
      entityType,
      extendFilterType: filterKeyMap.REGION_EXTEND_TYPE.common,
      default: defaultValue?.[filterKeyMap.REGION],
      visible: 1,
      options: [],
    },
  };

  const [inputList, setInputList] = useState([
    defaultInputList.GENRETOR,
    defaultInputList.RANGE_TIME,
    defaultInputList.REGION,
  ]);

  useEffect(() => {
    const inputListNew = inputList?.map((inputItem: any) => {
      const inputItemKey = inputItem?.key || inputItem?.type || '';
      switch (inputItemKey) {
        case filterKeyMap.GENRETOR: {
          return { ...inputItem, genresOptionsDataLoading, genresOptionsData };
        }
        case filterKeyMap.REGION: {
          return { ...inputItem, options: !Array.isArray(regionOptions) ? [] : regionOptions, getRadioOptionsTips };
        }
        default: {
          return { ...inputItem };
        }
      }
    });
    setInputList(inputListNew || []);
  }, [genresOptionsDataLoading, genresOptionsData, regionOptions, getRadioOptionsTips]);

  return (
    <Filter
      style={style}
      className={classnames('dbi-market-profile-filter', className)}
      showButton={false}
      inputList={inputList}
      defaultValue={defaultValue}
      value={value}
      onConfirm={onChange}
      onReset={onReset}
    />
  );
};

export default MarketProfilePCConsoleGamesFilter;
